<div class="join-section">
  <button mat-raised-button color="primary" (click)="joinChannel()">
    {{ 'NGX-MESSAGING.CHANNELS.joinChannel' | translate }}
  </button>
</div>
